import { Component, OnInit, Optional, Inject } from '@angular/core';
import { CompanyMaintenanceService } from 'src/app/pages/maintenance/company-maintenance/company-maintenance.service';
import { DialogService, LanguageService, AuthService } from "src/app/services";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from "src/environments/environment";
import { catchError, finalize } from "rxjs/operators";
import { of as observableOf} from "rxjs";
import * as _ from "lodash";
@Component({
  selector: 'esc-company-list',
  templateUrl: './company-list.component.html',
  styleUrls: ['./company-list.component.scss']
})
export class CompanyListComponent implements OnInit {
  public loading = {
    init: false,
    detail: false,
    more: false,
    export: false,
    import: false,
    error: false,
    detailError: false
  };
  companies = [];
  tableData: { web_filter: { limit: number; offset: number; keyword: string; is_asc: number; }; };

  private companyCount = 0;

  constructor(
    public dialogRef: MatDialogRef<CompanyListComponent>,
    private companyMntSvc: CompanyMaintenanceService,
    private dialogService: DialogService,
    private languageService: LanguageService,
    public authService: AuthService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.tableData = _.cloneDeep(INITIAL_OPTIONS);
    this.getListData();
  }

  getListData() {
    this.loading.detail = true;
    this.companyMntSvc.getListMapping(this.tableData).pipe(
      finalize(() => {
        this.loading.init = false;
        this.loading.more = false;
        return observableOf(null);
      }),
      catchError(err => {
        if (this.companies.length == 0) {
          this.loading.error = true;
        } else {
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INTERNAL_SERVER_ERROR", {}));
          this.tableData.web_filter.offset -= this.tableData.web_filter.limit;
        }
        this.loading.detail = false;
        return observableOf(null);
      }))
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        this.loading.detail = false;

        if (!res || res.status == 0 || res.status == 504 || res.status == 500) {
          this.loading.error = true;
          this.companies = [];
          this.dialogService.openSnackBar("ERROR");
          return;
        }
        if (_.has(res, "value") && _.toLower(res.value) == _.toLower("Success")) {
          // Filter the new companies, must have schema_name
          const newCompanies = res.data.filter(e => _.has(e, 'schema_name') && _.get(e, 'schema_name') != '');

          // Append to the existing companies
          this.companies.push(...newCompanies);

          // Get total company count
          this.companyCount = _.get(res, 'count');
        }
      });
  }

  changeSchema(company){
    this.dialogRef.close(_.get(company, 'schema_name'));
  }

  getMore() {
    if (this.loading.more || this.loading.init || this.companies.length >= this.companyCount) {
      return;
    }

    this.tableData.web_filter.offset += this.tableData.web_filter.limit;
    this.getListData(); 
  }

}

const INITIAL_OPTIONS = {
  web_filter: {
    limit: 50,
    offset: 0,
    keyword: "",
    is_asc: 1,
    industry_type_ids:[0],
    status: null
  }
};
